import { Stack, Tag, Text, Wrap, WrapItem } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiTag } from "react-icons/fi";
import { PublicContextDto } from "../../../autogen/bff-api";
import { LabelValueGrid } from "../../sourcing-events/portal/view-single/LabelValueGrid";
import { SectionCard } from "../../sourcing-events/portal/view-single/SectionCard";

const DASH = "–";

export const ClassificationSection = ({ publicContext: pc }: { publicContext: PublicContextDto }) => {
  const { t } = useTranslation();
  const yesNo = (v?: boolean | null) => (v == null ? DASH : v ? t("Yes") : t("No"));
  const cpv = pc.cpvCodes ?? [];

  return (
    <SectionCard icon={FiTag} title={t("Classification and rules")}>
      <Stack spacing="5">
        <Stack spacing="1">
          <Text color="smMuted" fontSize="xs" fontWeight="semibold" textTransform="uppercase" letterSpacing="wide">
            {t("CPV codes")}
          </Text>
          {cpv.length > 0 ? (
            <Wrap>
              {cpv.map((code) => (
                <WrapItem key={code}>
                  <Tag colorScheme="teal" borderRadius="full">
                    {code}
                  </Tag>
                </WrapItem>
              ))}
            </Wrap>
          ) : (
            <Text color="smText" fontSize="sm">
              {DASH}
            </Text>
          )}
        </Stack>
        <LabelValueGrid
          rows={[
            { label: t("Regulation"), value: pc.regulation ? t(pc.regulation) : DASH },
            { label: t("FOA part"), value: pc.foaPart ? t(pc.foaPart) : DASH },
            { label: t("Framework agreement"), value: pc.frameworkAgreement ? t(pc.frameworkAgreement) : t("No") },
            {
              label: t("Dynamic purchasing system"),
              value: pc.dynamicPurchasingSystem ? t(pc.dynamicPurchasingSystem) : t("No"),
            },
            { label: t("Electronic auction"), value: yesNo(pc.electronicAuction) },
            { label: t("GPA coverage"), value: yesNo(pc.gpaCoverage) },
            { label: t("EU funded"), value: yesNo(pc.euFunded) },
            { label: t("Accelerated procedure"), value: yesNo(pc.acceleratedProcedure) },
          ]}
        />
      </Stack>
    </SectionCard>
  );
};
